import { validate as isUuid } from 'uuid'

import { routes } from '@redwoodjs/router'

/** Query param for deep-linking to a saved table view on the staff records list. */
export const RECORDS_LIST_VIEW_UUID_QUERY_PARAM = 'viewUuid'

export const parseRecordsListViewUuidFromSearch = (search: string): string | null => {
  const raw = new URLSearchParams(search).get(RECORDS_LIST_VIEW_UUID_QUERY_PARAM)?.trim()
  if (!raw || !isUuid(raw)) {
    return null
  }
  return raw
}

export const recordsListPathWithViewUuid = ({
  recordTypeId,
  viewUuid,
}: {
  recordTypeId: number
  viewUuid: string
}) => {
  const path = routes.recordsList({ recordTypeId })
  const params = new URLSearchParams({ [RECORDS_LIST_VIEW_UUID_QUERY_PARAM]: viewUuid })
  return `${path}?${params.toString()}`
}
